import { Match } from '../models/match.model';
import { Round } from '../models/round.model';
import { WinnerOf } from '../models/winner-of.model';

const getRoundAlias = (currentRound: number, totalRounds: number) => {
  const remainingRounds = totalRounds - currentRound;
  switch (remainingRounds) {
    case 2:
      return 'quarter-finals';
    case 1:
      return 'semi-finals';
    case 0:
      return 'finals';
    default:
      return `round-${currentRound}`;
  }
};

export const generateRemainingRounds = (
  totalRounds: number,
  playInMatches: Array<Match>,
  capacityMatches: Array<Match>
): Array<Round> => {
  playInMatches = playInMatches || [];
  const additionalRounds: Round[] = [];
  let previousRoundMatches = capacityMatches;

  let currentMatchId = capacityMatches.length + playInMatches.length;
  let nextRoundMatches = [];

  // For each additional round beyond capacity round
  // ... r = 2 because the first 2 rounds are already calculated
  for (let r = 2; r <= totalRounds; r++) {
    if (previousRoundMatches.length === 1) {
      continue;
    }

    // Iterate sequentially through the previous round's matches
    // Ordinal position of the previous round matters.
    for (let m = 0; m < previousRoundMatches.length; m += 2) {
      const firstMatch = previousRoundMatches[m];
      const secondMatch = previousRoundMatches[m + 1];

      nextRoundMatches.push(<Match>{
        id: ++currentMatchId,
        slot1: new WinnerOf(firstMatch),
        slot2: new WinnerOf(secondMatch),
      });
    }

    additionalRounds.push(<Round>{
      alias: getRoundAlias(r, totalRounds),
      matches: nextRoundMatches,
    });

    previousRoundMatches = nextRoundMatches;
    nextRoundMatches = [];
  }

  return additionalRounds;
};
